<template>
  <div class="person">
    <div class="pt-2">
      {{ title }}
    </div>

    <div class="row">
      <div class="col-12">
        <w-radio-list :model="model.gender" :values="gender" />
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <w-input :model="model.firstName" />
      </div>

      <div class="col-6">
        <w-input :model="model.lastName" />
      </div>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';
import { GENDER } from '@/utils/constants';

export default {
  mixins: [componentMixin],
  data() {
    return {
      gender: GENDER
    };
  }
};
</script>

<style>
.person p.label {
  margin-bottom: 0.5rem !important;
}
</style>
